import React from "react";
import ProductForm from "./productForm";

const AddProduct = (props) => {
  return <ProductForm mode="ADD" userId={props.userId} />;
};

export default AddProduct;
